class ApiError extends Error {
  constructor(message) {
    super(message);
  }
}

export default function apiFetch(path, options) {
  return fetch(`https://${process.env.API_HOST}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-vt-requestid': window.components?.tracking?.request_id,
    },
    mode: 'cors',
    ...options,
  }).then((response) => response.json()).then((data) => {
    if (data.error) { throw new ApiError(data.error); }
    return data;
  });
}
